<template>
  <b-modal
    id="componentEditModal"
    title="Редактор элемента"
    ref="componentEditModal"
    header-bg-variant="primary"
    header-text-variant="light"
    ok-title="Сохранить"
    cancel-title="Отмена"
    ok-variant="primary"
    cancel-variant="outline-primary"
    size="lg"
    @ok="onOk"
    @cancel="onCancel"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    @shown="onShown"
  >
    <div v-if="element">
      <b-row>
        <b-col>
          <b-form-group label="id">
            <b-form-input type="number" v-model="element.id" number />
          </b-form-group>
          <b-form-group label="Функция отображения">
            <b-form-select
              v-model="element.displayFunction"
              :options="functions"
              @change="updateLayers"
            />
          </b-form-group>
          <b-form-group label="Расширение зоны перерисовки">
            <b-row align-v="start">
              <b-col sm="8">
                <b-form-input
                  v-model="extendRedraw"
                  type="range"
                  min="0.005"
                  max="10"
                  step="0.005"
                />
              </b-col>
              <b-col sm="4">
                <b-form-input type="number" v-model="extendRedraw" />
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col>
          <label> {{ drawError ? 'Ошибка отображения' : 'Предпросмотр' }}</label>
          <TrainingPanel
            v-show="drawError === null"
            ref="panel"
            :dummyPanel="dummyPanel"
          />
          <pre
            v-show="drawError !== null"
            class="bg-danger componentModal__preview-error p-2"
            >{{ drawError }}</pre
          >
        </b-col>
      </b-row>
      <b-tabs
        card
        :key="key"
        v-model="layerTab"
        v-if="element.layers.length > 0"
      >
        <b-tab
          v-for="(layer, index) in element.layers"
          :title="`Слой ${index}`"
          :key="layer.id"
        >
          <b-row>
            <b-col class="p-2">
              <ImgOrTile :obj="layer.texture" />
            </b-col>
            <b-col>
              <b-button variant="outline-primary" @click="onSelect(index)"
                >Выбрать ресурс</b-button
              >
              <b-form-group
                v-if="!Number.isInteger(layer.texture)"
                label="Текстура в тайлсете"
              >
                <b-form-select
                  v-model="layer.texture.textureName"
                  @change="updateLayers"
                  :options="resources.tilesets[layer.texture.tileset].names"
                />
              </b-form-group>
              <CoordsEditor v-model="layer.coords" :size="null" />
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </div>
    <ResourceModal
      select
      modalId="componentResourceModal"
      @resourceSelected="onResourceSelected"
    />
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CoordsEditor from '@/components/content/education/training/tools/CoordsEditor.vue'
import ImgOrTile from '@/components/content/education/training/tools/ImgOrTile.vue'
import ResourceModal from '@/components/content/education/training/modals/ResourceModal.vue'
import TrainingPanel from '@/components/content/education/training/TrainingPanel.vue'

const makeDummy = (element) => {
  const dummy = {
    id: 0,
    name: 'dummy',
    sizes: {
      canvas: {
        w: 390,
        h: 390
      },
      container: {
        w: 400,
        h: 400
      }
    }
  }
  if (element) {
    dummy.items = [
      {
        id: 0,
        coords: {
          x: 50,
          y: 50,
          w: 300,
          h: 300
        },
        itemId: element.id,
        displayFunctionValues: { ...element.displayFunctionValues }
      }
    ]
    dummy.itemsById = { 0: dummy.items[0] }
  } else {
    dummy.items = []
    dummy.itemsById = []
  }
  return dummy
}

export default {
  name: 'ComponentEditModal',
  components: {
    CoordsEditor,
    ImgOrTile,
    ResourceModal,
    TrainingPanel
  },
  data() {
    return {
      extendRedraw: 1,
      selectIndex: 0,
      key: 0,
      layerTab: 0,
      dummyPanel: makeDummy(),
      drawError: null
    }
  },
  props: {
    elementId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  watch: {
    elementId() {
      this.updateParams()
    }
  },
  mounted() {
    this.updateParams()
  },
  computed: {
    ...mapGetters({
      elements: 'training/getElements',
      resources: 'training/getResources'
    }),
    element() {
      return this.elements.itemsById[this.elementId]
    },
    functions() {
      return Array.from(Object.keys(this.elements.module))
    }
  },
  methods: {
    onShown() {
      this.updateLayers()
    },
    updateParams() {
      if (!this.elements.itemsById[this.elementId]) {
        return
      }
      this.dummyPanel = makeDummy(this.element)
      const { extendRedraw } = this.elements.itemsById[this.elementId]
      if (extendRedraw) {
        this.extendRedraw = String(extendRedraw)
      }
    },
    updatePreview() {
      this.dummyPanel = makeDummy(this.element)
      this.key += 1
      setTimeout(() => {
        try {
          this.$refs.panel.initPanel()
          this.drawError = null
        } catch (e) {
          this.drawError = e.stack
        }
      }, 0)
    },
    onSelect(index) {
      this.selectIndex = index
      this.$bvModal.show('componentResourceModal')
    },
    onResourceSelected(resource) {
      if (resource.type === 'resource-texture') {
        this.element.layers[this.selectIndex].texture = resource.id
      }
      if (resource.type === 'resource-tileset') {
        const tileset = this.resources.tilesets[resource.id]
        this.element.layers[this.selectIndex].texture = {
          tileset: resource.id,
          textureName: tileset.names[0]
        }
      }
      this.updateLayers()
    },
    updateLayers() {
      this.updatePreview()
      this.key += 1
    },
    onOk() {
      this.element.extendRedraw = Number(this.extendRedraw)
      this.$emit('updateElement')
    },
    onCancel() {
      this.$emit('resetElement')
    }
  }
}
</script>

<style scoped>
.componentModal__preview-canvas {
  height: 100%;
  width: 100%;
}

.componentModal__preview-error {
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
}
</style>
